var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIPasswordSuccess = function SvgIPasswordSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 127,
    viewBox: "0 0 203 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.243 35.9631L95.1244 68.8055C93.1492 70.7069 90.0182 70.6658 88.1175 68.69C83.7208 64.1194 75.996 55.9624 70.2781 49.235C61.8289 39.2941 44.5642 52.3316 52.5444 63.3907L78.2583 92.1446C86.7704 103.115 96.2875 99.9597 99.982 97.0106L147.42 50.5612C162.617 35.3962 144.441 20.7977 129.243 35.9631Z",
    fill: "#3AD98A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.105 25.7753C116.907 21.7335 117.971 18.2088 119.73 14.5215",
    stroke: "#3AD98A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7911 23.6824C88.8764 18.8774 85.3186 8.06702 84.2347 3.02002",
    stroke: "#3AD98A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5222 33.2552L60.2435 21.5994",
    stroke: "#3AD98A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6544 90.7872C29.6751 89.554 35.6426 92.7261 34.7049 99.8178C33.9734 105.351 40.8162 107.15 45.3776 104.451",
    stroke: "#AFB0BE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06056 16.0487C11.1412 18.9064 11.3717 25.6491 4.74784 28.3847C-0.420262 30.5191 1.43956 37.3318 6.06268 39.9239",
    stroke: "#AFB0BE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.165 1.1974C185.764 4.59524 183.696 10.2653 177.286 10.3256C172.284 10.3726 171.545 16.644 174.511 20.3359",
    stroke: "#AFB0BE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.25 53.0075C202.25 56.7451 199.213 59.7778 195.463 59.7778C191.713 59.7778 188.676 56.7451 188.676 53.0075C188.676 49.27 191.713 46.2373 195.463 46.2373C199.213 46.2373 202.25 49.27 202.25 53.0075Z",
    stroke: "#AFB0BE",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6841 122.459C83.6841 124.625 81.9241 126.382 79.7507 126.382C77.5773 126.382 75.8173 124.625 75.8173 122.459C75.8173 120.293 77.5773 118.535 79.7507 118.535C81.9241 118.535 83.6841 120.293 83.6841 122.459Z",
    stroke: "#AFB0BE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.826 73.3563C160.826 75.2779 159.264 76.8376 157.336 76.8376C155.407 76.8376 153.846 75.2779 153.846 73.3563C153.846 71.4347 155.407 69.875 157.336 69.875C159.264 69.875 160.826 71.4347 160.826 73.3563Z",
    stroke: "#AFB0BE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.339 101.998C139.429 100.911 141.286 101.408 141.684 102.893L144.668 114.005C145.068 115.492 143.706 116.854 142.218 116.457L131.081 113.479C129.592 113.081 129.096 111.222 130.186 110.133L138.339 101.998Z",
    fill: "#3AD98A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3655 49.6135C28.7642 48.1287 30.6211 47.6322 31.7105 48.7192L34.742 51.744C35.8329 52.8325 35.336 54.692 33.8479 55.0899L29.7068 56.1971C28.2187 56.5949 26.8566 55.2324 27.2559 53.7455L28.3655 49.6135Z",
    fill: "#3AD98A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIPasswordSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-password-success.911cd3488e83242ccd76f3bcc30ca593.svg";